import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { extend } from 'flarum/common/extend';
import formatNumber from 'flarum/common/utils/formatNumber';
import Icon from 'flarum/common/components/Icon';
import Button from 'flarum/common/components/Button';
import PostsUserPage from 'flarum/forum/components/PostsUserPage';

/**
 * Scrubber de navigation dans les messages d'un utilisateur.
 *
 * Contrairement au PostStreamScrubber d'une discussion, la page utilisateur
 * repose sur PostListState et des pages API. Le scrubber travaille cependant
 * en nombre de messages : un index absolu est converti en page, puis en
 * position dans cette page.
 */
class UserPostsScrubber extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.posts = this.attrs.posts;
    this.user = this.attrs.user;
    this.index = 0;
    this.dragging = false;
    this.mouseStart = 0;
    this.indexStart = 0;
    this.handlers = {};
    this.scrollFrame = null;
  }
  view() {
    const count = this.count();
    const viewing = () => app.translator.trans('core.forum.post_scrubber.viewing_text', {
      count,
      index: m("span", {
        className: "Scrubber-index"
      }),
      formattedCount: m("span", {
        className: "Scrubber-count"
      }, formatNumber(count))
    });
    const classNames = ['PostStreamScrubber', 'UserPostsScrubber', 'Dropdown'];
    if (this.attrs.className) classNames.push(this.attrs.className);
    return m("div", {
      className: classNames.join(' ')
    }, m("button", {
      type: "button",
      className: "Button Dropdown-toggle",
      "data-toggle": "dropdown"
    }, viewing(), " ", m(Icon, {
      name: "fas fa-sort"
    })), m("div", {
      className: "Dropdown-menu dropdown-menu"
    }, m("div", {
      className: "Scrubber"
    }, m(Button, {
      className: "Scrubber-first Button Button--link",
      onclick: () => this.goToFirst(),
      icon: "fas fa-angle-double-up"
    }, "Premier message"), m("div", {
      className: "Scrubber-scrollbar"
    }, m("div", {
      className: "Scrubber-before"
    }), m("div", {
      className: "Scrubber-handle"
    }, m("div", {
      className: "Scrubber-bar"
    }), m("div", {
      className: "Scrubber-info"
    }, m("strong", null, viewing()), m("span", {
      className: "Scrubber-description"
    }))), m("div", {
      className: "Scrubber-after"
    })), m(Button, {
      className: "Scrubber-last Button Button--link",
      onclick: () => this.goToLast(),
      icon: "fas fa-angle-double-down"
    }, "Dernier message"))));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.index = this.currentIndexFromDom();
    this.updateScrubberValues();
    this.onresize();
    this.handlers.onresize = () => this.onresize();
    this.handlers.onscroll = () => {
      if (this.dragging || this.scrollFrame !== null) return;
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        if (!this.dragging) {
          this.index = this.currentIndexFromDom();
          this.updateScrubberValues();
        }
      });
    };
    $(window).on('resize', this.handlers.onresize).on('scroll', this.handlers.onscroll);
    this.$('.Scrubber-scrollbar').on('click', e => this.onclick(e)).on('dragstart mousedown touchstart', e => e.preventDefault());
    this.$('.Scrubber-handle').on('mousedown touchstart', e => this.onmousedown(e)).on('click', e => e.stopPropagation());
    this.handlers.onmousemove = e => this.onmousemove(e);
    this.handlers.onmouseup = e => this.onmouseup(e);
    $(document).on('mousemove touchmove', this.handlers.onmousemove).on('mouseup touchend', this.handlers.onmouseup);
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    if (!this.dragging) {
      this.index = this.currentIndexFromDom();
    }
    this.updateScrubberValues();
    this.onresize();
  }
  onremove(vnode) {
    super.onremove(vnode);
    if (this.scrollFrame !== null) {
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
    }
    $(window).off('resize', this.handlers.onresize).off('scroll', this.handlers.onscroll);
    $(document).off('mousemove touchmove', this.handlers.onmousemove).off('mouseup touchend', this.handlers.onmouseup);
  }
  count() {
    if (this.posts.totalItems !== null && this.posts.totalItems !== undefined) {
      return Number(this.posts.totalItems) || 0;
    }

    // Sur un document préchargé, PostListState rc.8 ne recopie pas
    // forcément meta.page.total dans totalItems. On le récupère donc ici.
    const pages = this.posts.getPages ? this.posts.getPages() : [];
    for (const page of pages) {
      const total = page?.items?.payload?.meta?.page?.total;
      if (total !== undefined && total !== null) {
        return Number(total) || 0;
      }
    }

    // Disponible immédiatement via le modèle User.
    return Number(this.user?.commentCount?.() || 0);
  }
  pageSize() {
    if (this.posts.pageSize) {
      return Number(this.posts.pageSize);
    }
    const pages = this.posts.getPages ? this.posts.getPages() : [];
    for (const page of pages) {
      const perPage = page?.items?.payload?.meta?.perPage;
      if (perPage) return Number(perPage);
    }
    return 20;
  }
  loadedPages() {
    if (!this.posts.getPages) return [];
    return this.posts.getPages().filter(page => Number(page.number) >= 1);
  }
  firstLoadedPage() {
    const pages = this.loadedPages();
    if (pages.length) {
      return Number(pages[0].number);
    }
    return Number(this.posts.getLocation?.().page || 1);
  }
  clampIndex(index) {
    const count = this.count();
    if (!count) return 0;
    return Math.max(0, Math.min(count - 1, index));
  }

  /**
   * Détermine quel message actuellement rendu est le premier visible.
   */
  currentIndexFromDom() {
    const count = this.count();
    if (!count) return 0;
    const elements = Array.from(document.querySelectorAll('.PostsUserPage .Post'));
    const base = (this.firstLoadedPage() - 1) * this.pageSize();
    if (!elements.length) {
      return this.clampIndex(base);
    }

    // Un peu sous le haut de fenêtre pour tenir compte du header Flarum.
    const marker = Math.min(140, window.innerHeight * 0.2);
    let visible = 0;
    for (let i = 0; i < elements.length; i++) {
      const rect = elements[i].getBoundingClientRect();
      if (rect.top <= marker) {
        visible = i;
      } else {
        break;
      }
    }
    return this.clampIndex(base + visible);
  }
  updateScrubberValues() {
    if (!this.element) return;
    const count = this.count();
    const index = this.clampIndex(this.index);
    const $scrubber = this.$();
    const $scrollbar = $scrubber.find('.Scrubber-scrollbar');
    $scrubber.find('.Scrubber-index').text(formatNumber(count ? index + 1 : 0));
    $scrubber.find('.Scrubber-count').text(formatNumber(count));
    $scrubber.find('.Scrubber-description').text('');
    $scrubber.toggleClass('disabled', count <= 1 || this.posts.isLoading?.());
    if (!$scrollbar.length) return;
    const scrollbarHeight = $scrollbar.outerHeight() || 300;

    // Même principe que le scrubber Flarum :
    // poignée jamais plus petite que 50 px.
    const minHandlePercent = Math.min(100, 50 / scrollbarHeight * 100);
    const naturalHandlePercent = count > 0 ? 100 / count : 100;
    const handlePercent = Math.min(100, Math.max(naturalHandlePercent, minHandlePercent));
    const availablePercent = 100 - handlePercent;
    const beforePercent = count > 1 ? index / (count - 1) * availablePercent : 0;
    const afterPercent = 100 - beforePercent - handlePercent;
    $scrubber.find('.Scrubber-before').css('height', Math.max(0, beforePercent) + '%');
    $scrubber.find('.Scrubber-handle').css('height', Math.max(0, handlePercent) + '%');
    $scrubber.find('.Scrubber-after').css('height', Math.max(0, afterPercent) + '%');
  }
  onresize() {
    if (!this.element) return;
    const $scrubber = this.$();
    const $scrollbar = $scrubber.find('.Scrubber-scrollbar');
    if (!$scrollbar.length) return;
    $scrollbar.css('max-height', $(window).height() - $scrubber.offset().top + $(window).scrollTop() - parseInt($('#app').css('padding-bottom'), 10) - ($scrubber.outerHeight() - $scrollbar.outerHeight()));
    this.updateScrubberValues();
  }
  eventClientY(e) {
    if (e.clientY !== undefined) return e.clientY;
    const touches = e.originalEvent?.touches;
    if (touches && touches.length) {
      return touches[0].clientY;
    }
    const changedTouches = e.originalEvent?.changedTouches;
    if (changedTouches && changedTouches.length) {
      return changedTouches[0].clientY;
    }
    return 0;
  }
  onmousedown(e) {
    e.redraw = false;
    this.mouseStart = this.eventClientY(e);
    this.indexStart = this.index;
    this.dragging = true;
    $('body').css('cursor', 'move');
    this.$().addClass('dragging');
  }
  onmousemove(e) {
    if (!this.dragging) return;
    const count = this.count();
    if (count <= 1) return;
    const height = this.$('.Scrubber-scrollbar').outerHeight() || 1;
    const deltaPixels = this.eventClientY(e) - this.mouseStart;
    const deltaIndex = deltaPixels / height * (count - 1);
    this.index = this.clampIndex(Math.round(this.indexStart + deltaIndex));
    this.updateScrubberValues();
  }
  onmouseup() {
    if (!this.dragging) return;
    this.dragging = false;
    this.mouseStart = 0;
    this.indexStart = 0;
    $('body').css('cursor', '');
    this.$().removeClass('dragging open');
    this.goToIndex(Math.round(this.index));
  }
  onclick(e) {
    const $scrollbar = this.$('.Scrubber-scrollbar');
    if (!$scrollbar.length) return;
    const rect = $scrollbar[0].getBoundingClientRect();
    const y = this.eventClientY(e) - rect.top;
    const ratio = Math.max(0, Math.min(1, y / (rect.height || 1)));
    const target = Math.round(ratio * Math.max(0, this.count() - 1));
    this.index = this.clampIndex(target);
    this.updateScrubberValues();
    this.goToIndex(this.index);
    this.$().removeClass('open');
  }
  goToFirst() {
    this.goToIndex(0);
  }
  goToLast() {
    this.goToIndex(Math.max(0, this.count() - 1));
  }

  /**
   * Va à un index absolu de message.
   */
  goToIndex(index) {
    const count = this.count();
    if (!count) return;
    const target = this.clampIndex(index);
    const pageSize = this.pageSize();
    const page = Math.floor(target / pageSize) + 1;
    this.index = target;
    this.updateScrubberValues();

    // Si la page est déjà chargée, aucune requête nécessaire.
    const alreadyLoaded = this.loadedPages().some(loadedPage => Number(loadedPage.number) === page);
    if (alreadyLoaded) {
      this.scrollToAbsoluteIndex(target);
      return;
    }
    this.posts.goto(page).then(() => {
      m.redraw();

      // Laisser Mithril poser les nouveaux posts dans le DOM.
      setTimeout(() => {
        this.index = target;
        this.updateScrubberValues();
        this.scrollToAbsoluteIndex(target);
      }, 0);
    }).catch(() => {});
  }

  /**
   * Se place sur le message exact à l'intérieur des pages actuellement rendues.
   */
  scrollToAbsoluteIndex(target) {
    setTimeout(() => {
      const elements = Array.from(document.querySelectorAll('.PostsUserPage .Post'));
      if (!elements.length) {
        const page = document.querySelector('.PostsUserPage');
        if (page) {
          const y = page.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({
            top: Math.max(0, y),
            behavior: 'smooth'
          });
        }
        return;
      }
      const base = (this.firstLoadedPage() - 1) * this.pageSize();
      const localIndex = Math.max(0, Math.min(elements.length - 1, target - base));
      const element = elements[localIndex];
      if (!element) return;
      const y = element.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({
        top: Math.max(0, y),
        behavior: 'smooth'
      });
    }, 0);
  }
}
app.initializers.add('val-ui-user-posts-scrubber', () => {
  extend(PostsUserPage.prototype, 'content', function (content) {
    if (!content || !this.posts || !this.user) return;
    const count = Number(this.user.commentCount?.() || 0);
    if (count <= 1) return;
    content.attrs ||= {};
    content.attrs.className = ((content.attrs.className || '') + ' ValUserPostsPage').trim();
    const children = Array.isArray(content.children) ? content.children : content.children ? [content.children] : [];
    children.push(m("aside", {
      className: "ValUserPostsScrubberSlot"
    }, m(UserPostsScrubber, {
      posts: this.posts,
      user: this.user
    })));
    content.children = children;
  });
});